import React from "react";
import ClassStudentFeeSummary from "./ClassStudentFeeSummary";

const TotalRecieved = () => (
  <ClassStudentFeeSummary
    title="Total Received"
    metricKey="total_recieved"
    metricLabel="Received"
    accentColor="#22c55e"
    showOnlyPositive
  />
);

export default TotalRecieved;
